import React, {useEffect,useMemo,useContext, useState} from 'react';
import '../App.css';
import { useMst ,RootStoreContext} from '../models/root';
import { observer } from "mobx-react-lite";
import {Link} from "react-router-dom";
import TinderCard from 'react-tinder-card'
import OIP from "../assets/images/OIP.jpeg"

const alreadyRemoved = []

const APPLY_WHEN_SENDING_HOME = 4;

const Home = observer(()=>{
    const {variables,othersIdeas} = useContext(RootStoreContext);

    const childRefs = useMemo(() => Array(othersIdeas.oilLength()).fill(0).map(i => React.createRef()), [])
    const see = Array(othersIdeas.oilLength()).fill(false)
    const [wn, setWelcomeNote] = useState(false)
    const [ssc, setSeeSchedule] = useState(false)
    useEffect(()=>{
        variables._e(0);
        variables._e(APPLY_WHEN_SENDING_HOME);
    },[])

    function swipe(){

    };

    function swiped(){

    };
    
    function outOfFrame(){

    };

    return(
        <div className='flex '>
        <div class="sm:w-2/5 w-full">
            <div class="h-4 bg-pink-500"></div>
            <div><div class="block sm:hidden bg-blue-700 text-white p-2">Door</div></div>
            <div class="flex my-4 justify-around flex-row">
                <Link  class="flex-initial w-24 text-center h-8" to={{pathname:"/idea",state:{function:1}}}>
                    <div><p><span class="text-sm">+</span> Add Idea</p>
                    </div>
                </Link>
                <Link class="flex-initial rounded text-white bg-blue-700 w-24 text-center h-8" to={{pathname:"/nominate",state:{fromHome:1}}}>
                    <div >
                        <p class="pt-0.5">Nominate</p>
                    </div>
                </Link>
            </div>
            <div class="my-4 flex  justify-around">
                <div class="w-60 h-8 bg-pink-300 text-center rounded pt-0.5"><p>Your Ideas</p></div>
            </div>
            <div class="w-full my-4 h-64 bg-blue-200">
            {othersIdeas.ideas.map((idea, index) =>
                <TinderCard ref={childRefs[index]} className='swipe' key={idea.id} onSwipe={(dir) => swiped(dir, idea.id)} onCardLeftScreen={() => outOfFrame(idea.id)}>
                    <div className='card'>
                        <p>{idea.text}</p>
                        <div class="absolute w-1/12 h-8 bg-yellow-400 text-center left-3 bottom-3">
                            <p class="font-bold">{idea.whisper_score}</p>
                        </div>
                        {see[index]&&<div class="w-3/12 bg-yellow-400 absolute text-center px-2 left-3 -bottom-16">
                            <p class="font-bold">{idea.whisper_score}</p>
                            <p class="font-bold">Whisper Score</p>
                            <p>Number of times idea has been improved</p>
                        </div>}
                    </div>
                </TinderCard>
                 )}
            </div>
            <div class="flex my-8 justify-around flex-row">
                    <div class="flex-initial rounded text-white bg-blue-700 h-10 w-28 text-center">
                        <Link to={{pathname:"/idea",state:{function:3}}}><p class="pt-1.5 text-sm">Improve Idea</p></Link>
                    </div>
                    <div onClick={() => swipe('right')} class="flex-initial rounded my-1 w-20 border-2 h-8 text-center"><p class="pt-0.5">Next</p>
                    </div>
            </div>

            <div class="w-full text-center">
                <p class="text-sm">- All ideas are anonymous</p>
            </div>
            <div class="w-full text-center">
                <p class="text-sm">- You can only see ideas of your own college</p>
            </div>
            <div className='h-8'></div>
            <div class="p-3 w-full h-16 left-0 text-xs">
                <div class="w-10/12 h-6">
                    <div class="flex">
                        <p>What else do you want?</p>
                    </div>
                </div>
            </div>

        </div>
        <div class="w-3/5 sm:block hidden">
            <div class='flex justify-end'>
                <div class="flex-1 border-2 border-black m-2 p-1 text-xs text-gray-600">Student Search</div>
            </div>
            
            <div className='text-xs flex gap-4'>
            <div className='py-2 px-4 text-center w-2/5'>Use Canva To Make an Art/Science Work Piece</div>
            <div className='mt-2 mb-2 px-4 py-2 bg-blue-700 text-white rounded'>
                Upload Door Pic
            </div>
            <div className='mt-2 mb-2 px-4 py-2 bg-blue-700 text-white rounded'>
                Add a Welcome Note
            </div>
            </div>
            <div className='w-full h-full mt-12'>
            <div className='m-auto w-10/12 h-96 text-xs border-2 relative'>
                <img src={OIP} className='w-full h-full'/>
                <div className='absolute top-12 left-1/2'>
                    <div onClick={()=>setWelcomeNote(!wn)} class="px-2 py-1 rounded-full bg-white font-bold border-2 border-black">
                        W
                    </div>
                </div>
                {wn&&<div className='absolute top-20 left-16 bg-white px-4 py-2'>I am the leader of Kyuang in Dota! Accepting 2 new members.</div>}
                <div className='absolute bottom-1/3 left-1/3 flex flex-row gap-4 w-full'>
                    <div className='bg-white border-2 border-black w-4/12 pl-1 pt-1'>Schedule Meeting</div>
                    <div class="px-2 py-1 rounded-full bg-white font-bold border-2 border-black">S</div>
                </div>
            </div>
            </div>

            <div class="absolute top-1/2 left-1/2 translate-y-2/4 translate-x-2/4 border-2 border-black bg-white">
                <div>
                    <div>Invitations</div>
                    <div>Sent</div>
                </div>
                <div>
                    <div>
                        <div>Abha Sharma</div>
                        <div>Confirm</div>
                    </div>
                </div>
                <div>
                <div>
                    <div>Abha Sharma</div>
                    <div>Confirmed</div>
                </div>
                <div>
                    <div>Abha Sharma</div>
                    <div>Unconfirmed</div>
                </div>
                </div>
            </div>

        </div>
        </div>

    )
})

export default Home;



